import request from '@/utils/request';
export function ueditorConfig(query) {
  return request({
    url: '/sys/ueditor/todo',
    method: 'get',
    params: query
  });
}